import React from "react";
import { deepEqual } from "../../utils/object";
import { Col, Row, Form, Accordion } from "react-bootstrap";

class FeraPermissions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [...new Set(props?.permissions?.map(o => o.category))]
        }
    }

    isChecked = (name, defaultValue) => {
        if (this.props.active) return this.props.active.includes(name);
        return defaultValue;
    }

    componentDidUpdate = (prevProps) => {
        if (!deepEqual(prevProps.permissions, this.props.permissions)) {
            this.setState({
                categories: [...new Set(this.props.permissions.map(o => o.category))]
            });
        }
    }

    onChange = (object, permission) => {
        if (this.props.onChange) {
            const result = [...this.props.active];
            const idx = result.indexOf(permission.name);
            if (idx >= 0) {
                result.splice(idx, 1);
            } else {
                result.push(permission.name);
            }
            this.props.onChange({ target: {name: permission.name, value: idx < 0}, collection: result });
        }        
    }

    render() {
        return (
            <Accordion>
                {this.state?.categories?.map((category, index) => {
                    const items = this.props.permissions.filter(i => i.category?.trim() === category);
                    return (
                        <Accordion.Item eventKey={index} key={`permission.item.${index}`}>
                            <Accordion.Header as="div" style={{marginLeft: "1rem"}}>{category}&nbsp;</Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    {items?.map((permission, itemIndex) => {
                                        return (
                                            <Col xs="12" md="6" lg="4" xll="3" key={`permission.col.${category}.${itemIndex}`}>
                                                <Form.Check onChange={(e) => this.onChange(e, permission)} type="switch" defaultChecked={this.isChecked(permission.name, permission.default)} id={permission.name} label={permission.description} />
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    );
                })}
            </Accordion>
        )
    }
}

export default FeraPermissions;